<template>
    <div>
        <!-- Tabel Sarana -->
        <div class="card">
            <div class="card-header">
                <div class="col-12 col-lg-12">
                    <div class="row">
                        <div class="col-6 col-lg-6 order-1 order-lg-1">
                            <h5
                                style="
                                    vertical-align: middle !important;
                                    float: left !important;
                                "
                            >
                                Data Servis Sarana (Light Vihicle)
                                
                            </h5>
                        </div>
                        <div class="col-6 col-lg-6 order-2 order-lg-2">
                            <div class="col-12 col-lg-12">
                                <div class="d-flex justify-content-end">
                                    <a href="/sarana/servis/show" target="_blank"
                                        class="btn btn-sm btn-primary me-2"
                                        type="button"
                                    >
                                        <span class="tf-icons bx bx-plus"></span
                                        >&nbsp; Buat Data Service
                                        </a>
                                    <button
                                        ref="updateBtn"
                                        id="showToastPlacement"
                                        class="btn btn-sm btn-warning"
                                        type="button"
                                        @click="getService(halaman)"
                                    >
                                        <span
                                            class="tf-icons bx bx-refresh"
                                        ></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive text-nowrap">
                <table class="table table-hover">
                    <caption class="ms-4" v-if="services.total > 0">
                        Showing
                        {{
                            services.from
                        }}
                        to
                        {{
                            services.to
                        }}
                        of
                        {{
                            services.total
                        }}
                        Sarana
                    </caption>
                    <thead>
                        <tr>
                            <th>Nomor</th>
                            <th>Unit Sarana</th>
                            <th>Kilometer Unit</th>
                            <th>Servis Berkala</th>
                            <th>Servis General</th>
                            <th>Catatan</th>
                            <th>Waktu</th>
                        </tr>
                    </thead>
                    <tfoot>
                        <tr>
                            <th>Nomor</th>
                            <th>Unit Sarana</th>
                            <th>Kilometer Unit</th>
                            <th>Servis Berkala</th>
                            <th>Servis General</th>
                            <th>Catatan</th>
                            <th>Waktu</th>
                        </tr>
                    </tfoot>
                    <tbody class="table-border-bottom-0">
                        <tr v-for="(a, b) in services.data" >
                            
                            <td>
                                <strong>{{ services.from + b }}</strong>
                                &nbsp;
                                <a :href="'/sarana/servis/'+a.kodeUnit+'/edit'" target="_blank"
                                        class="btn btn-xs btn-primary me-2"
                                        type="button"
                                    >
                                        <span class="tf-icons bx bx-show"></span
                                        >&nbsp; Lihat
                                        </a>
                            </td>
                            <td>{{ a.noLambung }} <br> {{ a.merkType }}</td>
                            <td>{{ a.kilometerUnit }}</td>
                            <td>{{ a.kilometerBerkala }}</td>
                            <td>{{ a.kilometerGeneral }}</td>
                            <td>{{ a.catatan }}</td>
                            <td>{{ a.hari }} , {{ moment(a.tanggal).format("DD MMMM YYYY") }}<br>{{ a.jam }}</td>
                        </tr>
                        <tr v-if="services.total == 0">
                            <td>Tidak Ada Data</td>
                        </tr>
                    </tbody>
                </table>
                <div style="margin-top: 100px;">

                </div>
            </div>
            <div class="card-footer">
                <Bootstrap5Pagination
                    :data="services"
                    @pagination-change-page="getService"
                />
            </div>
        </div>
        <!--/ Hoverable Table rows -->
        <!-- Form Sarana -->
        <form-sarana
            @tabelSaranaEmit="doEmits"
            ref="focusRef"
            :tokens="tokens"
        ></form-sarana>

        <detail-sarana
            ref="focusDetailRef"
        ></detail-sarana>
    </div>
</template>

<script>
import axios from "axios";
import { Bootstrap5Pagination } from "laravel-vue-pagination";
import FormSarana from "./form/lv.vue";
import { ref } from "vue";
import moment from "moment";
import QrcodeVue, { QrcodeCanvas, QrcodeSvg ,ImageSettings} from 'qrcode.vue'

const focusRef = ref(null);

export default {
    components: {
        Bootstrap5Pagination,
        FormSarana,
        QrcodeSvg,
        QrcodeCanvas,
        QrcodeVue,
    },
    mounted() {
        this.csrfTokens = this.tokens;
        this.getService(this.halaman);
        var thisFocus = this;
        var myOffcanvas = document.getElementById("offcanvasBoth");

        myOffcanvas.addEventListener("shown.bs.offcanvas", () => {
            thisFocus.$refs.focusRef.focusInputs();
        });
    },
    data() {
        return {
            moment: moment,
            vehicles: {},
            services:{},
            halaman: 1,
            csrfTokens: "",
        };
    },
    props: ["tokens"],
    methods: {
        toast() {
            $("#myToast").toast("show");
        },
        getVehicle(page) {
            if (page != undefined) {
                this.halaman = page;
            }
            axios
                .get("/sarana/lv/create?page=" + this.halaman)
                .then((response) => {
                    var vehicle = response.data;
                    if (vehicle != null) {
                        this.vehicles = vehicle;
                    }
                });
        },
        getService(page) {
            if (page != undefined) {
                this.halaman = page;
            }
            axios
                .get("/sarana/servis/create?page=" + this.halaman)
                .then((response) => {
                    var service = response.data;
                    if (service != null) {
                        this.services = service;
                    }
                });
        },

        doEmits() {
            this.getVehicle(this.halaman);
        },
        inputFocusEvent() {
            var thisFocus = this;
            var myOffcanvas = document.getElementById("offcanvasBoth");

                thisFocus.$refs.focusRef.initDatas();
            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);

            bsOffcanvas.toggle();
        },
        editSarana(id) {
            var thisFocus = this;
            var myOffcanvas = document.getElementById("offcanvasBoth");
            thisFocus.$refs.focusRef.getByIds(id);
            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);
            bsOffcanvas.toggle();
        },
        detailSarana(id) {
            var thisFocus = this;
            var myOffcanvas = document.getElementById("offcanvasDetailBoth");
            thisFocus.$refs.focusDetailRef.getByIds(id);
            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);
            bsOffcanvas.toggle();
        },
        
    },
};
</script>